module.exports = __webpack_public_path__ + "img/iphone.df213ccc.png";